__turbopack_context__.v({
  "embla": "EmblaCarousel-module__OjaXZG__embla",
  "emblaButtonContainer": "EmblaCarousel-module__OjaXZG__emblaButtonContainer",
  "emblaContainer": "EmblaCarousel-module__OjaXZG__emblaContainer",
  "emblaItem": "EmblaCarousel-module__OjaXZG__emblaItem",
  "emblaItemStretchHeight": "EmblaCarousel-module__OjaXZG__emblaItemStretchHeight",
  "selected": "EmblaCarousel-module__OjaXZG__selected",
});
